import * as React from "react";
import { Badge } from "components/bootstrap";
function SecurityEventsCount({ events }) {
  return /* @__PURE__ */ React.createElement(Badge, { bsStyle: "default" }, events);
}
export default SecurityEventsCount;
